"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _validate = require("@/utils/validate");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryZiti',
  components: {
    CommonUpload: _commonUpload.default
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sendStatus: {
      type: Number,
      default: null
    },
    deliveryLog: {
      type: Object,
      default: null
    },
    customerInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    submitting: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initiator: {
      type: String,
      default: ''
    },
    initiateTime: {
      type: String,
      default: ''
    },
    sendTaskId: {
      type: [String, Number],
      default: null
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      auditing: false
    };
  },
  computed: {
    previewAttachmentList: function previewAttachmentList() {
      var _this = this;

      var data = this.form.pickupAttachment;
      if (!data) return [];

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        return raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = parsed.alias || parsed.localName || parsed.realName || '';

          var isImage = _this.isImageFile(name);

          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            url: parsed.url || prefix + parsed.realName,
            name: name,
            isImage: isImage
          };
        });
      } catch (_unused) {
        return [];
      }
    },
    deliveryChecklistPhotoList: function deliveryChecklistPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.deliveryChecklistPhoto);
    },
    deliveryLoadingCompletePhotoList: function deliveryLoadingCompletePhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.deliveryLoadingCompletePhoto);
    }
  },
  methods: {
    // ==================== 审核方法 ====================
    handleReject: function handleReject() {
      var _this2 = this;

      if (!this.form.csAuditOpinion || !this.form.csAuditOpinion.trim()) {
        this.$message.warning('请填写您的审批意见');
        return;
      }

      this.$confirm('确定驳回该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.doAudit(1011);
      }).catch(function () {});
    },
    handleApprove: function handleApprove() {
      var _this3 = this;

      this.$confirm('确定同意该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.doAudit(1010);
      }).catch(function () {});
    },
    doAudit: function doAudit(status) {
      var _this4 = this;

      this.auditing = true;
      var contractNumber = this.contractList && this.contractList.length > 0 ? this.contractList[0].contractNumber || this.contractList[0].contractNo || this.contractList[0].custContractNo || '' : '';
      (0, _send.addSendTaskLog)({
        sendTaskId: this.sendTaskId,
        sendNumber: this.form.deliveryNo || '',
        contractNumber: contractNumber,
        step: String(status),
        remark: this.form.csAuditOpinion || ''
      }).then(function () {
        _this4.$message.success(status === 1011 ? '已驳回' : '已同意');

        _this4.$emit('audit-done');
      }).catch(function (error) {
        console.error('审核操作失败:', error);

        _this4.$message.error('操作失败，请重试');
      }).finally(function () {
        _this4.auditing = false;
      });
    },
    // ==================== 附件处理 ====================
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return imgExtensions.includes(ext);
    },
    downloadAttachment: function downloadAttachment(item) {
      if (item.url) {
        fetch(item.url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          window.open(item.url, '_blank');
        });
      }
    },
    handleAttachmentUpload: function handleAttachmentUpload(filePaths) {
      this.form.pickupAttachment = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleAttachmentDel: function handleAttachmentDel(filePaths) {
      this.form.pickupAttachment = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleLoadingCompletePhotoUpload: function handleLoadingCompletePhotoUpload(filePaths) {
      this.form.loadingCompletePhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleLoadingCompletePhotoDel: function handleLoadingCompletePhotoDel(filePaths) {
      this.form.loadingCompletePhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleChecklistPhotoUpload: function handleChecklistPhotoUpload(filePaths) {
      this.form.deliveryChecklist = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleChecklistPhotoDel: function handleChecklistPhotoDel(filePaths) {
      this.form.deliveryChecklist = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    // ==================== $refs methods ====================
    fillFromEdit: function fillFromEdit(row) {
      var _this5 = this;

      if (!row) return;
      this.form.pickupDate = row.pickupDate;

      if (row.pickupTime) {
        if (Array.isArray(row.pickupTime)) {
          this.form.pickupTime = row.pickupTime;
        } else {
          var parts = row.pickupTime.split('-');
          this.form.pickupTime = parts.length === 2 ? parts : ['', ''];
        }
      } else {
        this.form.pickupTime = ['', ''];
      }

      this.form.pickupWarehouseLocation = row.storageLocation || '';
      this.form.pickupDeliveryPerson = row.sender || '';
      this.form.remark = row.remark || '';
      this.form.licensePlate = row.selfCarNumber || '';
      this.form.driverName = row.selfDeliver || '';
      this.form.driverPhone = row.selfPhone || '';
      this.form.loadingOrder = row.loadingOrder || 1;
      this.form.pickupAttachment = row.pickupAttachment || row.attachment || '';
      this.form.receivePerson = row.receivePerson || this.customerInfo.contactPerson || '';
      this.form.receivePhone = row.receivePhone || this.customerInfo.contactNumber || '';
      this.form.receiveAddress = row.receiveAddress || this.customerInfo.contactAddress || '';
      this.form.deliveryChecklist = row.deliveryChecklist || '';
      this.form.loadingCompletePhoto = row.loadingCompletePhoto || ''; // 恢复附件

      if (row.pickupAttachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('pickupAttachment', row.pickupAttachment);
        });
      } else if (row.attachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('pickupAttachment', row.attachment);
        });
      }

      if (row.deliveryChecklist) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('checklistPhotoUpload', row.deliveryChecklist);
        });
      }

      if (row.loadingCompletePhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('loadingCompletePhotoUpload', row.loadingCompletePhoto);
        });
      }
    },
    fillFromCache: function fillFromCache(saveData) {
      var _this6 = this;

      if (!saveData) return;
      if (saveData.pickupDate) this.form.pickupDate = this._formatDateStr(saveData.pickupDate);

      if (saveData.pickupTime) {
        if (Array.isArray(saveData.pickupTime)) {
          this.form.pickupTime = saveData.pickupTime;
        } else {
          var parts = saveData.pickupTime.split('-');
          this.form.pickupTime = parts.length === 2 ? parts : ['', ''];
        }
      }

      if (saveData.licensePlate || saveData.selfCarNumber) this.form.licensePlate = saveData.licensePlate || saveData.selfCarNumber;
      if (saveData.driverName || saveData.selfDeliver) this.form.driverName = saveData.driverName || saveData.selfDeliver;
      if (saveData.driverPhone || saveData.selfPhone) this.form.driverPhone = saveData.driverPhone || saveData.selfPhone;
      if (saveData.pickupWarehouseLocation || saveData.storageLocation) this.form.pickupWarehouseLocation = saveData.pickupWarehouseLocation || saveData.storageLocation;
      if (saveData.pickupDeliveryPerson || saveData.sender) this.form.pickupDeliveryPerson = saveData.pickupDeliveryPerson || saveData.sender;
      if (saveData.remark) this.form.remark = saveData.remark;
      if (saveData.loadingOrder) this.form.loadingOrder = saveData.loadingOrder;

      if (saveData.pickupAttachment) {
        this.form.pickupAttachment = saveData.pickupAttachment;
        this.$nextTick(function () {
          return _this6._restoreAttachment('pickupAttachment', saveData.pickupAttachment);
        });
      } else if (saveData.attachment) {
        this.form.pickupAttachment = typeof saveData.attachment === 'string' ? saveData.attachment : JSON.stringify(saveData.attachment);
        this.$nextTick(function () {
          return _this6._restoreAttachment('pickupAttachment', _this6.form.pickupAttachment);
        });
      }

      if (saveData.deliveryChecklist) this.form.deliveryChecklist = saveData.deliveryChecklist;
      if (saveData.loadingCompletePhoto) this.form.loadingCompletePhoto = saveData.loadingCompletePhoto;
    },
    buildSaveData: function buildSaveData() {
      return {
        pickupDate: this.form.pickupDate,
        pickupTime: this.form.pickupTime,
        loadingOrder: this.form.loadingOrder,
        licensePlate: this.form.licensePlate,
        driverName: this.form.driverName,
        driverPhone: this.form.driverPhone,
        pickupWarehouseLocation: this.form.pickupWarehouseLocation,
        pickupDeliveryPerson: this.form.pickupDeliveryPerson,
        remark: this.form.remark,
        pickupAttachment: this.form.pickupAttachment,
        deliveryChecklist: this.form.deliveryChecklist,
        loadingCompletePhoto: this.form.loadingCompletePhoto
      };
    },
    getSubmitDataPatch: function getSubmitDataPatch(submitData) {
      submitData.sendDate = this.form.pickupDate || '';
      submitData.sendTime = Array.isArray(this.form.pickupTime) ? this.form.pickupTime.filter(Boolean).join('-') : this.form.pickupTime || '';
      submitData.storageLocation = this.form.pickupWarehouseLocation || '';
      submitData.sender = this.form.pickupDeliveryPerson || '';
      submitData.remark = this.form.remark || '';
      submitData.selfCarNumber = this.form.licensePlate || '';
      submitData.selfDeliver = this.form.driverName || '';
      submitData.selfPhone = this.form.driverPhone || '';
      submitData.loadingOrder = this.form.loadingOrder || 1;

      if (this.form.pickupAttachment) {
        submitData.attachment = this.form.pickupAttachment;
      }

      return submitData;
    },
    fillFromSendInfo: function fillFromSendInfo(row) {
      this.fillFromEdit(row);
    },
    buildDeliverySubmitPhoto: function buildDeliverySubmitPhoto() {
      var parseVal = function parseVal(v) {
        if (!v) return v;

        try {
          return JSON.parse(v);
        } catch (_unused2) {
          return v;
        }
      };

      return {
        deliveryChecklistPhoto: parseVal(this.form.deliveryChecklist),
        deliveryLoadingCompletePhoto: parseVal(this.form.loadingCompletePhoto)
      };
    },
    getRules: function getRules() {
      return {
        pickupDate: [{
          required: true,
          message: '请选择期望提货日期',
          trigger: 'change'
        }],
        pickupTime: [{
          required: true,
          trigger: 'change',
          validator: this.validatePickupTime
        }],
        loadingOrder: [{
          required: true,
          message: '请输入装车顺序',
          trigger: 'blur'
        }],
        licensePlate: [{
          required: true,
          message: '请输入车牌',
          trigger: 'blur'
        }],
        driverName: [{
          required: true,
          message: '请输入司机姓名',
          trigger: 'blur'
        }],
        driverPhone: [{
          required: true,
          message: '请输入司机电话',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        receivePerson: [{
          required: true,
          message: '请输入收货人',
          trigger: 'blur'
        }],
        receivePhone: [{
          required: true,
          message: '请输入收货人电话',
          trigger: 'blur'
        }, {
          validator: _validate.validatePhone,
          trigger: 'blur'
        }],
        receiveAddress: [{
          required: true,
          message: '收货信息必填',
          trigger: 'change'
        }],
        pickupWarehouseLocation: [{
          required: true,
          message: '请输入仓库位置',
          trigger: 'blur'
        }],
        pickupDeliveryPerson: [{
          required: true,
          message: '请输入发货人',
          trigger: 'blur'
        }]
      };
    },
    fillDeliveryInfo: function fillDeliveryInfo(deliveryLog) {
      return {
        deliveryChecklistPhoto: deliveryLog.deliveryChecklistPhoto || [],
        deliveryLoadingCompletePhoto: deliveryLog.deliveryLoadingCompletePhoto || []
      };
    },
    // ==================== 校验方法 ====================
    validatePickupTime: function validatePickupTime(rule, value, callback) {
      if (!value || !Array.isArray(value) || !value[0] || !value[1]) {
        callback();
        return;
      }

      var startParts = value[0].split(':').map(Number);
      var endParts = value[1].split(':').map(Number);
      var startMinutes = startParts[0] * 60 + startParts[1];
      var endMinutes = endParts[0] * 60 + endParts[1];

      if (endMinutes <= startMinutes) {
        callback(new Error('结束时间不能小于开始时间'));
        return;
      }

      callback();
    },
    // ==================== 辅助方法 ====================
    parsePhotoList: function parsePhotoList(data) {
      if (!data) return [];

      try {
        var arr = Array.isArray(data) ? data : typeof data === 'string' ? JSON.parse(data) : [];
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        return arr.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          return {
            url: parsed.url || imgPreviewPrefix + parsed.realName,
            name: parsed.alias || parsed.localName || parsed.realName || ''
          };
        });
      } catch (_unused3) {
        return [];
      }
    },
    _restoreAttachment: function _restoreAttachment(refName, data) {
      var ref = this.$refs[refName];
      if (!ref) return;

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        var files = raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = (parsed.alias || parsed.localName || parsed.realName || '').toLowerCase();
          var isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'].some(function (e) {
            return name.endsWith(e);
          });
          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            realName: parsed.realName,
            url: parsed.url || prefix + parsed.realName,
            type: parsed.type,
            alias: parsed.localName || parsed.alias
          };
        });
        ref.setFileList(files);
      } catch (e) {}
    },
    _formatDateStr: function _formatDateStr(val) {
      if (!val) return '';
      var d = val instanceof Date ? val : new Date(val);
      if (isNaN(d.getTime())) return '';
      return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'));
    }
  }
};
exports.default = _default2;